import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Subscription } from 'xstate';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  private authStatusSubscription!: Subscription;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthenticatorService,
  ) {}

  ngOnInit() {
    this.authStatusSubscription = this.authService.subscribe(({ authStatus }) => {
      if (authStatus === 'authenticated') {
        this.router.navigate(['invoices']);
      } else if (authStatus === 'unauthenticated') {
        this.router.navigate(['login']);
      }
    });
  }

  ngOnDelete() {
    this.authStatusSubscription.unsubscribe();
  }
}
